import * as Api from './api';

export function updateSettings(data) {
  return { type: 'SETTINGS_UPDATE', data };
}

export function settingsError(error) {
  return { type: 'SETTINGS_ERROR', error };
}

export function fetchSettings(embeddedWidgetId) {
  return (dispatch) => {
    Api.getEmbeddedWidget(embeddedWidgetId)
      .then((data) => {
        dispatch(updateSettings(data));
      })
      .catch((error) => {
        dispatch(settingsError(error));
      });
  };
}

const claimsScreenshotSettings = {
  migrationType: 'KiwiOnly',
  hasZipCodeProtection: true,
  isClaimsScreenshot: true,
};

export function fetchTrackingPageSettings(trackingPageId) {
  return async (dispatch) => {
    if (trackingPageId === 'claims-screenshot') {
      dispatch(updateSettings(claimsScreenshotSettings));
      return claimsScreenshotSettings;
    }

    try {
      const data = await Api.getTrackingPageSettings(trackingPageId);
      dispatch(updateSettings(data));
      return data;
    } catch (error) {
      dispatch(settingsError(error));
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/actions/settings.js